module.exports = __webpack_public_path__ + "img/logo_derecha.e2f53618.jpg";